import {Component, computed, inject, input} from "@angular/core";
import {SearchableColumn} from "@models";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {AdministrationTableFormService} from "../administration-table-form.service";
import {toSignal} from "@angular/core/rxjs-interop";

@Component({
	selector: "sim-administration-table-applied-filters",
	templateUrl: "./administration-table-applied-filters.component.html",
	styleUrl: "./administration-table-applied-filters.component.scss",
	animations: [zoomInOnEnterAnimation({duration: 175}), zoomOutOnLeaveAnimation({duration: 175})],
	standalone: false,
})
export class AdministrationTableAppliedFiltersComponent {
	protected formService = inject(AdministrationTableFormService);

	public readonly searchableColumns = input.required<SearchableColumn[]>();

	readonly #formValue = toSignal(this.formService.formGroup.valueChanges);

	public readonly appliedFilters = computed<SearchableColumn[]>(() =>
		computeAppliedFilters(this.#formValue() as Record<string, unknown> | undefined, this.searchableColumns()),
	);
}

function computeAppliedFilters(valueMap: Record<string, unknown> | undefined, searchableColumns: SearchableColumn[]) {
	return searchableColumns.filter((column) => {
		const value = valueMap?.[column.value];
		return isFilterApplied(value);
	});
}

function isFilterApplied(value: unknown): boolean {
	return (Array.isArray(value) ? value.length > 0 : true) && value !== null && value !== undefined && value !== "";
}
